import { render, staticRenderFns } from "./AppointmentCreatedToCustomer.vue?vue&type=template&id=79c42a54"
import script from "./AppointmentCreatedToCustomer.vue?vue&type=script&lang=js"
export * from "./AppointmentCreatedToCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports